import { AbstractInputService } from './AbstractInputService';
import { IInputService } from './inputServiceTypes';

export class InputServiceStub
	extends AbstractInputService
	implements IInputService
{
	private escButtonEnabled = true;

	public async setEscButtonEnabled(isEnabled: boolean): Promise<void> {
		if (this.escButtonEnabled === isEnabled) {
			return;
		}

		// console.log('input:setEscButtonEnabled', { isEnabled });
		this.escButtonEnabled = isEnabled;
	}

	public async setAnyInputFocused(isFocused: boolean): Promise<void> {
		this.setIsAnyInputFocusedLocal(isFocused);

		console.log('input:setAnyInputFocused', { isFocused });
	}
}
